import { render, staticRenderFns } from "./fertilizerPro.vue?vue&type=template&id=60e21864&scoped=true&"
import script from "./fertilizerPro.vue?vue&type=script&lang=js&"
export * from "./fertilizerPro.vue?vue&type=script&lang=js&"
import style0 from "./fertilizerPro.vue?vue&type=style&index=0&id=60e21864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e21864",
  null
  
)

export default component.exports